<template>
    <form-input-layout :active="active" :help-item-code="helpItemCode">
        <template slot="caption" v-if="!noCaption">
            {{ caption }}<strong v-if="required" class="required">*</strong>
        </template>
        <template slot="input">
            <div style="position: relative;">
                <input :class="{ 'input-component': true, 'active': active}"
                       @focus="onFocus"
                       @blur="onBlur"
                       @click="showSelectionList($event)"
                       @keydown="showSelectionList($event)"
                       @keydown.esc="hideSelectionList"
                       @keydown.down="move(+1)"
                       @keydown.up="move(-1)"
                       @keydown.enter="keySelectItem"
                       :placeholder="placeholder"
                       v-model="selectionText"/>
                <div class="selection-list" v-if="selectionListVisible" :key="selectionText">
                    <div :class="{'selection-list-item': true, 'selection-list-item-key': option == keySelector}"
                         :ref="option.id" :key="option.id" v-for="option in filteredOptions"
                         @click="selectItem(option)">
                        <div :style="{'grid-area': customRenderer != null ? '1/1/1/2' : '1/1/1/3'}">
                            <template v-if="nameFunction">
                                {{ nameFunction(option) }}
                            </template>
                            <template v-else>
                                {{ option.name }}
                            </template>
                        </div>
                        <div v-if="customRenderer != null" style="grid-area: 1/2/1/3;">
                            <component :is="customRenderer" v-bind="{ item: option }"/>
                        </div>
                    </div>
                </div>
            </div>

        </template>
    </form-input-layout>
</template>

<script>
import FormInputLayout from "./FormInputLayout";
import { Vue } from "vue";

export default {
    name: "FormSelectInput",
    components: {FormInputLayout},
    props: {
        noCaption: Boolean,
        options: Array,
        value: String,
        caption: String,
        customRenderer: Vue,
        disabled: Boolean,
        required: Boolean,
        nameFunction: Function,
        idFunction: Function,
        helpItemCode: String
    },
    computed: {
        placeholder() {
            const actualValue = this.options?.filter(option => option.id == this.internalValue) ?? "";
            if (actualValue.length > 0) {
                if (this.nameFunction)
                    return this.selectionText = this.nameFunction(actualValue[0]);
                else
                    return this.selectionText = actualValue[0].name;
            } else return "N/A"
        },
        filteredOptions() {
            if (this.nameFunction) {
                return [{
                    id: null,
                    name: "N/A"
                }, ...this.options.filter(option => `${option.id}`.toLowerCase().indexOf(this.selectionText.toLowerCase()) > -1
                  || `${this.nameFunction(option)}`.toLowerCase().indexOf(this.selectionText.toLowerCase()) > -1)];
            } else {
                return [{
                    id: null,
                    name: "N/A"
                }, ...this.options.filter(option => option.name.toLowerCase().indexOf(this.selectionText.toLowerCase()) > -1
                  || option.name.toLowerCase().indexOf(this.selectionText.toLowerCase()) > -1)];
            }
        }
    },
    data: function () {
        return {
            selectionListVisible: false,
            selectionText: "",
            internalValue: null,
            active: false,
            keySelector: null
        }
    },
    methods: {
        move(direction) {
            if (this.keySelector == null) {
                this.keySelector = this.filteredOptions[0];
            } else {
                const idx = this.filteredOptions.indexOf(this.keySelector);
                if (!(idx == this.filteredOptions.length - 1 && direction == 1) &&
                  !(idx == 0 && direction == -1)) {
                    this.keySelector = this.filteredOptions[idx + direction];
                }

            }

            //this.$refs[this.keySelector.id][0].scrollIntoView(false);
        },
        keySelectItem() {
            this.selectItem(this.keySelector);
        },
        onFocus() {
            this.active = true;
            this.selectionText = "";
            this.showSelectionList();
        },
        onBlur() {
            this.active = false;
        },
        showSelectionList($event) {
            this.selectionListVisible = true;
            setTimeout(() => {
                document.getElementById('app').addEventListener('click', this.hideSelectionList, false);
            }, 250);
        },
        hideSelectionList() {
            this.selectionListVisible = false;
            this.selectionText = this.getSelectionText();
            document.getElementById('app').removeEventListener('click', this.hideSelectionList, false);
        },
        toggleActive() {
            this.active = !this.active;
        },
        selectItem(option) {
            this.internalValue = option.id;
            this.selectionListVisible = false;
            this.$emit('input', this.internalValue);
        },
        getSelectionText() {
            const actualValue = this.options.filter(option => option.id == this.internalValue);
            if (actualValue.length > 0) {
                if (this.nameFunction)
                    return this.selectionText = this.nameFunction(actualValue[0]);
                else
                    return this.selectionText = actualValue[0].name;
            } else return "N/A";
        }
    },
    mounted() {
        this.selectionListVisible = false;
    },
    watch: {

        options() {

            const actualValue = this.options.filter(option => option.id == this.internalValue);
            if (actualValue.length == 0) {
                this.selectionText = null;
                return;
            }
            if (this.nameFunction)
                this.selectionText = this.nameFunction(actualValue[0]);
            else
                this.selectionText = actualValue[0].name;
        },
        internalValue() {
            if (this.options?.length > 0) {
                const actualValue = this.options.filter(option => option.id == this.internalValue);
                if (actualValue.length > 0) {
                    if (this.nameFunction)
                        return this.selectionText = this.nameFunction(actualValue[0]);
                    else
                        return this.selectionText = actualValue[0].name;
                } else this.selectionText = "N/A"
            }
            this.$emit('input', this.internalValue);
        },
        value: {
            handler(newVal) {
                if (newVal !== undefined)
                    this.internalValue = newVal;
            },
            immediate: true
        }
    }
}

</script>

<style lang="scss" scoped>
@import "../../styles/global";

.selection-list {
    display: block;
    background-color: var(--input-list-background-color);
    width: 100%;
    position: absolute;
    z-index: 9999;
    overflow-y: scroll;
    max-height: 150px;
}

.selection-list-item {
    display: grid;
    align-items: center;
    grid-template-columns: 3fr 5fr;
    padding: 5px;
}

.selection-list-item:hover {
    color: var(--input-active-font-color);
    background-color: var(--input-list-selection-color);
    cursor: pointer;
}

.input-component {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid var(--input-border-color);
    background-color: var(--input-background-color);
    color: var(--input-font-color);
    padding: 5px 10px 5px 10px;
    outline: none;
    width: 100%;
    font-size: $inputFontSize;
    font-family: Source Sans Pro;
}

.active {
    color: var(--input-active-font-color);
    background-color: var(--input-active-background-color);
    border-bottom: 1px solid var(--input-active-border-color);
}

.required {
    color: var(--accent-color);
}

.input-component::placeholder {
    color: var(--input-placeholder-font-color);
}

.selection-list-item-key {
    background-color: $openRed;
}

</style>